// ActionProvider starter code
class ActionProvider {
  constructor(createChatBotMessage, setStateFunc, createClientMessage) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createClientMessage = createClientMessage;
  }

  greet = () => {
    const mess = this.createChatBotMessage("Hello Visitor...");
    this.addMessageToState(mess);
  };

  food = () => {
    const mess = this.createChatBotMessage(
      "My Favorite is : 🍙🍙Xiao Long Bao🍙🍙"
    );
    this.addMessageToState(mess);
  };

  wine = () => {
    const mess = this.createChatBotMessage(
      "My Favorite is : 🍷 Pinot Grigio and"
    );
    const m = this.createChatBotMessage("🍷 Chardonnay");

    this.addMessageToState(mess);
    this.addMessageToState(m);
  };

  handleJavascriptQuiz = () => {
    const message = this.createChatBotMessage(
      "You can reach me with below details:",
      {
        widget: "contactUs",
      }
    );

    this.addMessageToState(message);
  };

  handleFood = () => {
    const message = this.createChatBotMessage("Below are my fav food:", {
      widget: "food",
    });
    this.addMessageToState(message);
  };

  addMessageToState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };
}

export default ActionProvider;
